import Service from "../../AuthService";
const RentalFee = {
    getRentalFee(page) {
        return Service.get("/rental_fee?page="+page);
    },
    showRentalFee(id) {
        console.log("/rental_fee/" + id);
        return Service.get("/rental_fee/" + id);
    },
    updateRentalFee(id, data) {
        return Service.put("/rental_fee/" + id, data);
    },
    createRentalFee(data) {
        return Service.post("/rental_fee", data);
    },
    deleteRentalFee(id) {
        return Service.delete("/rental_fee/" + id);
    },
    searchRentalFee(data){
        return Service.post('/rental_fee_search',data);
    },
    getRentalFeeAll(){
        return Service.get("/rental_fee_all");
    },
};
export default RentalFee;
